import React, { forwardRef } from "react";
import styled from "styled-components";

interface ScrollBoxProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    $trackcolor?: string;
    $handlecolor?: string;
    $handlecoloractive?: string;
    $marginbottom?: number;
    $scrollX?: boolean;
}

const ScrollBox = styled.div<ScrollBoxProps>`
    overflow-y: ${(props) => (props.$scrollX ? "hidden" : "overlay")};
    overflow-x: ${(props) => (props.$scrollX ? "overlay" : "hidden")};

    &::-webkit-scrollbar {
        width: 8px;
        height: 5px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${(props) => props.$handlecolor};
        border-radius: 5px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background-color: ${(props) => props.$handlecoloractive};
    }
    &::-webkit-scrollbar-thumb:active {
        background-color: ${(props) => props.$handlecoloractive};
    }
    &::-webkit-scrollbar-track {
        background-color: ${(props) => props.$trackcolor};
        border-radius: 5px;
        margin-bottom: ${(props) => props.$marginbottom}px;
    }
`;

interface CustomScrollBoxProps
    extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
    marginBottom?: number;
    scrollX?: boolean;

    $trackColor?: string;
    $handleColor?: string;
    $handleColorActive?: string;
}

// export default function

export const CustomScrollBox = forwardRef<HTMLDivElement, CustomScrollBoxProps>(
    (props, ref) => {
        const { marginBottom, scrollX, className, ...rest } = props;

        return (
            <ScrollBox
                ref={ref}
                // className={props.className}
                $trackcolor={props.$trackColor}
                $handlecolor={props.$handleColor}
                $handlecoloractive={props.$handleColorActive}
                $marginbottom={props.marginBottom ? props.marginBottom : 0}
                $scrollX={scrollX}
                className={
                    "customScrollBox fit-width " + className
                }
                {...rest}
            >
                {props.children}
            </ScrollBox>
        );
    }
);

// const CustomScrollTextArea = styled.textarea<ScrollBoxProps>`
//     overflow-y: overlay;
//     overflow-x: hidden;

//     &::-webkit-scrollbar {
//         width: 10px;
//     }
//     &::-webkit-scrollbar-thumb {
//         background-color: ${(props) => props.$handleColor};
//         border-radius: 5px;
//     }
//     &::-webkit-scrollbar-thumb:hover {
//         background-color: ${(props) => props.$handleColorActive};
//     }
//     ::-webkit-scrollbar-thumb:active {
//         background-color: ${(props) => props.$handleColorActive};
//     }
//     &::-webkit-scrollbar-track {
//         background-color: ${(props) => props.$trackColor};
//         border-radius: 5px;
//     }
// `;

// export const CustomTextArea = forwardRef(function (
//     props: CustomScrollBoxProps,
//     ref: any
// ) {

//     return (
//         <CustomScrollTextArea
//             ref={ref}
//             $trackColor={theme.colors.gray[900]}
//             $handleColor={theme.colors.gray[500]}
//             $handleColorActive={theme.colors.gray[400]}
//             $marginBottom={props.marginBottom ? props.marginBottom : 0}
//             {...props}
//         >
//             {props.children}
//         </CustomScrollTextArea>
//     );
// });
